import {
    ADD_QUERY_STRING,
    ADD_LOCATION_SEARCH
} from '../index'

const queryStringReducer = (state = {}, action) => {
    switch (action.type) {
        case ADD_QUERY_STRING:
            state = {
                ...state,
                queryString: action.payload
            }
            break;
            case ADD_LOCATION_SEARCH:
                state = {
                    ...state,
                    search: action.payload
                }
        default:
            return state
    };

    return state;
}

export default queryStringReducer;